import { TableProps } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Modal } from 'components/atoms/modal';
import { useWindowResize } from 'hooks/use-window-resize';
import { TemplateInsightBaseTable } from '../template-insight-base-table';

interface Props<T = any> extends TableProps<T> {
  visible: boolean;
  onCancel: () => void;
  titleLabel: string;
  renderEmpty: () => ReactNode;
}

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding: 0 !important;
  }
`;

export const ShowAllTable: FC<Props> = ({
  visible,
  onCancel,
  titleLabel,
  renderEmpty,
  ...tableProps
}) => {
  const { height: tableBodyHeight } = useWindowResize(
    (winHeight) => {
      const DEFAULT_HEIGHT = 500;
      const MODEL_PADDING_BOTTOM = 100;
      const { top } =
        document.querySelector('.ant-modal-body')?.getBoundingClientRect() ??
        {};

      if (!top) {
        return DEFAULT_HEIGHT;
      }

      return winHeight - top - MODEL_PADDING_BOTTOM;
    },
    [visible],
  );

  return (
    <StyledModal
      visible={visible}
      title={titleLabel}
      width={1500}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <TemplateInsightBaseTable
        {...tableProps}
        pagination={false}
        tableBodyHeight={tableBodyHeight}
        renderEmpty={renderEmpty}
      />
    </StyledModal>
  );
};
